<div class="action-bar">
    <slot />
    <slot name="bottom" />
</div>

<style>
    .action-bar {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        padding-bottom: 1rem;
        padding-top: 30px;
    }

    @media screen and (max-width: 700px) {
        .action-bar {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding-top : initial;
        }
    }
</style>
